import styled, { css } from 'styled-components';
import { th, variants } from 'style/theme';
import { sizes } from 'style';
import { motion } from 'framer-motion';

export const TooltipBoxWrapper = styled(motion.div)`
  position: absolute;
  top: 36px;
  left: 50%;
  transform: translateX(-50%);
  width: 180px;
  z-index: 1;

  ${variants('variant', {
    wide: css`
      width: 288px;
    `
  })};

  ${({ $followCursor }) =>
    $followCursor &&
    css`
      transform: none;
    `}

  > svg {
    position: absolute;
    top: -12px;
    left: 50%;
    transform: translateX(-50%);

    @media ${sizes.desktop} {
      display: none;
    }
  }
`;

export const StyledTooltipBox = styled(motion.div)`
  position: absolute;
  left: 0;
  top: 0;
  width: 180px;
  padding: 24px;
  border-radius: 32px;
  font-weight: 400;
  background-color: ${th('colors.fountainBlue+4')};
  color: ${th('colors.pickledBluewood')};
  box-shadow: ${th('shadows.largeShadow')};
  user-select: none;

  @media ${sizes.desktop} {
    left: 90px;

    ${({ $followCursor }) =>
      $followCursor &&
      css`
        position: fixed;
        left: 0;
        top: 0;
      `}
  }

  ${variants('variant', {
    wide: css`
      width: 288px;

      @media ${sizes.desktop} {
        left: 144px;
      }
    `
  })};
`;
